var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_vm._v("Copyright @ 2023 All Rights Reserved 加密统计 版权所有")])
}
var staticRenderFns = []

export { render, staticRenderFns }